import styled from "styled-components";

export const Title = styled.p`
    margin-top: 1rem;
    color: rgb(137, 137, 137);
    font-size: smDown ? 16px : 18px;
    font-weight: 400;
    text-align: center;
`;
